/**
 * Manutenzione Page - Page Shell
 * Lista ticket manutenzione
 */

import { TicketsList } from "@/features/manutenzione";

export default function Manutenzione() {
  return <TicketsList />;
}
